import { css } from 'styled-components';

export const gradients = {
  gradientPrimary: 'linear-gradient(-90deg, #f59a8a 10%, #fcbd96 80%)',
  gradientPeach: 'linear-gradient(-90deg, #fe9393 10%, #ffb6b6 80%)',
  gradientBlue: 'linear-gradient(-90deg, #acb4ff 10%, #939eff 80%)',
  gradientPurple: 'linear-gradient(-90deg, #e59aff 10%, #d280ef 80%)',
};

export const colors = {
  defaultWhite: '#ffffff',
  defaultGrey: '#f8f8f8',
  defaultSmoothBlack: '#272323',
  defaultBlack: '#000000',
  defaultBlackFive: 'rgba(0, 0, 0, 0.05)',
  defaultBlackTen: 'rgba(255, 255, 255, 0.1)',
  defaultBlackThirty: 'rgba(0, 0, 0, 0.3)',
  defaultWireframe: '#eeeeee',
  primaryPeach: '#f08080',
  primaryLightPeach: '#f8ad9d',
  secondarySunshine: '#fec89a',
  secondaryLightSunshine: '#f9dcc4',
  secondaryUltraLightSunshine: '#f8edeb',
  tertiaryKernel: '#633a41',
  stateResident: '#7984e6',
  stateResidentTen: 'rgba(121, 132, 230, 0.1)',
  statePart: '#ca79e6',
  statePartTen: 'rgba(202, 121, 230, 0.1)',
  stateEnCartons: '#e076af',
  stateEnCartonsTen: 'rgba(224, 118, 175, 0.1)',
  accentGreen: '#76e0a0',
  accentGreenTen: 'rgba(118, 224, 160, 0.1)',
  accentYellow: '#f0d180',
  accentRed: '#e67979',
  accentRedTen: 'rgba(230, 121, 121, 0.1)',
  accentBlue: '#79bfe6',
  accentBlueTen: 'rgba(121, 191, 230, 0.1)',
  accentGrey: '#b8b8b8',
  accentGreyTen: 'rgba(184, 184, 184, 0.1)',
  socialsYoutube: 'rgba(255, 0, 0, 1)',
  socialsTwitter: 'rgba(29, 161, 242, 1)',
  socialsTwitch: 'rgba(145, 70, 255, 1)',
  socialsInstagram: 'rgba(228, 64, 95, 1)',
  socialsFacebook: 'rgba(24, 119, 242, 1)',
  socialsReddit: 'rgba(255, 69, 0, 1)',
  socialsDiscord: 'rgba(88, 101, 242, 1)',
};

export const pxToRem = (px = 16) => `${px / 16}rem`;

export const layout = (px = 1170) => `
    max-width: ${pxToRem(px)};
    margin: 0 auto;
    padding: 0 ${pxToRem(8)};`;

const sizes = {
  large: 1200,
  medium: 992,
  small: 576,
};

// Iterate through the sizes and create a media template
export const media = Object.keys(sizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (min-width: ${sizes[label] / 16}rem) {
      ${css(...args)}
    }
  `;
  return acc;
}, {});
